import { SimpleGrid } from "@chakra-ui/react";
import {
    Wallet,
    BadgeCheck,
    Truck,
    Clock3,
} from "lucide-react";

import StatCard from "../../Dashboard/components/StatCard";

const AnalyticsStats = ({
    milestones = [],
    commissions = [],
    payouts = [],
}) => {
    const milestoneEarnings =
        milestones
            .filter(
                milestone =>
                    milestone.commission_status ===
                    "Paid"
            )
            .reduce(
                (sum, milestone) =>
                    sum +
                    Number(
                        milestone.commission_amount ||
                            0
                    ),
                0
            );

const deliveryEarnings =
    payouts
        .filter(
            payout =>
                payout.commission_id &&
                payout.status === "Paid"
        )
        .reduce(
            (sum, payout) =>
                sum +
                Number(
                    payout.amount || 0
                ),
            0
        );

    const pendingMilestoneCommission =
        milestones
            .filter(
                milestone =>
                    milestone.commission_status ===
                    "Pending"
            )
            .reduce(
                (sum, milestone) =>
                    sum +
                    Number(
                        milestone.commission_amount ||
                            0
                    ),
                0
            );

    const pendingDeliveryCommission =
        commissions
            .filter(
                commission =>
                    commission.record_type ===
                        "COMMISSION" &&
                    commission.commission_status ===
                        "Pending"
            )
            .reduce(
                (sum, commission) =>
                    sum +
                    Number(
                        commission.commission_amount ||
                            0
                    ),
                0
            );

    const pendingCommission =
        pendingMilestoneCommission +
        pendingDeliveryCommission;

    const totalEarnings =
        milestoneEarnings +
        deliveryEarnings;

    return (
        <SimpleGrid
            columns={{
                base: 1,
                sm: 2,
                xl: 4,
            }}
            gap={6}
            mb={8}
        >
            <StatCard
                title="Total Earnings"
                value={`P${totalEarnings.toFixed(
                    2
                )}`}
                subtitle="Milestones + deliveries"
                icon={
                    <Wallet
                        size={22}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Milestone Earnings"
                value={`P${milestoneEarnings.toFixed(
                    2
                )}`}
                subtitle="Referral milestone rewards"
                icon={
                    <BadgeCheck
                        size={22}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Delivery Earnings"
                value={`P${deliveryEarnings.toFixed(
                    2
                )}`}
                subtitle="Delivery commissions"
                icon={
                    <Truck
                        size={22}
                        color="#0F766E"
                    />
                }
            />

            <StatCard
                title="Pending Commission"
                value={`P${pendingCommission.toFixed(
                    2
                )}`}
                subtitle="Awaiting payout"
                icon={
                    <Clock3
                        size={22}
                        color="#F59E0B"
                    />
                }
            />
        </SimpleGrid>
    );
};

export default AnalyticsStats;